import {
  Component,
  OnInit,
  ViewEncapsulation,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { TranslateModule } from "@ngx-translate/core";
import { MatTableModule } from "@angular/material/table";
import { ApplicationDataService } from "../../core/services/application-data.service";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { ChangeDetectorRef } from "@angular/core";
import { MatSortModule, MatSort } from "@angular/material/sort";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { MatOptionModule } from "@angular/material/core";
import { MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { Config } from "../../core/DefaultConfig";
import { DatePipe } from "@angular/common";
import { MatTableDataSource } from "@angular/material/table";
import { debounceTime } from "rxjs";
import { Subject } from "rxjs";

@Component({
  selector: "app-dashboard-two",
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatSelectModule,
    MatOptionModule,
    MatGridListModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    TranslateModule,
    MatTableModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    MatPaginatorModule,
  ],
  templateUrl: "./dashboard-two.component.html",
  styleUrls: ["./dashboard-two.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardTwoComponent implements OnInit {
  rawData: any[] = [];
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = [
    "complaintNo",
    "complainantName",
    "complaintType",
    "cnic",
    "complaintDetails",
    "action",
  ];
  length = 0;
  displayColumns: string[] = [...this.displayedColumns];
  complaintProcessList: any[] = [];
  selectedColumns: { [key: string]: boolean } = {};
  originalComplaintProcessList: any[] = [];
  allComplaints: any[] = [];
  usersListOriginal: any[] = [];
  usersList: any[] = [];
  assignTo: string;
  assignRole: string;
  assignRoleAdmin: boolean;
  assignToUserName: string;
  complaintsByStatus: any = {};
  form: FormGroup;
  config = new Config();
  pageNo = 0;
  pageSize = 10;
  category: string;
  complainant: string;
  selectedStatus: string | null = null;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("searchCurrentProcess")
  searchCurrentProcess: ElementRef<HTMLInputElement>;

  userRole: string;

  constructor(
    private appDataService: ApplicationDataService,
    private router: Router,
    private location: Location,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    public elementRef: ElementRef
  ) {
    this.dataSource = new MatTableDataSource();
    this.dataSource.sortingDataAccessor = (item, property) => {
      const value = item[property];
      return typeof value === "string" ? value.toLowerCase() : value;
    };
    this.displayedColumns.forEach(
      (column) => (this.selectedColumns[column] = true)
    );
  }
  private assigneeSelectSubject = new Subject<string>();
  ngOnInit(): void {
    this.loadUserid();
    this.getAllUsersData();

    this.form = this.formBuilder.group({
      division: [""],
      district: [""],
      tehsil: [""],
      complaintType: [""],
      complaintSubType: [""],
      dateFrom: [],
      dateTo: [],
      complainantName: [""],
      complaintNo: [""],
      complaintCategoryId: [""],
      complaintSubcategoryId: [""],
      currentProcessId: [""],
      assignTo: [this.assignTo],
      assignToUserName: [this.assignToUserName],
    });
    this.getTotalComplaintsByUserStatusCount();

    // For dateFrom and dateTo
    this.f["dateFrom"].valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.clearCardSelection();
      this.resetPagination();
      this.getTotalComplaintsByUserStatusCount();
    });

    this.f["dateTo"].valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.clearCardSelection();
      this.resetPagination();
      this.getTotalComplaintsByUserStatusCount();
    });

    this.f["assignTo"].valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.clearCardSelection();
      this.resetPagination();
      this.getTotalComplaintsByUserStatusCount();
    });

  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
  deepCopy(data: any) {
    return JSON.parse(JSON.stringify(data));
  }
  getAllUsersData() {
    this.appDataService.getAllInternalUsers().subscribe({
      next: (res: any) => {
        this.usersListOriginal = res?.data || [];
        this.usersList = [...this.usersListOriginal];

        // Default: fields disable
        this.f["assignTo"].disable({ emitEvent: false });
        this.f["assignToUserName"].disable({ emitEvent: false });

        // Enable only for ADMIN or DASHBOARD
        if (this.userRole === "ADMIN" || this.userRole === "DASHBOARD") {
          this.f["assignTo"].enable({ emitEvent: false });
          this.f["assignToUserName"].enable({ emitEvent: false });
          this.assignRoleAdmin = false;
        } else {
          this.assignRoleAdmin = true;
        }

        // Assign selected user data
        const selectedUser = this.usersList.find(
          (user: any) => user.userId === this.assignTo
        );

        if (selectedUser) {
          this.assignToUserName = selectedUser.userName;
          this.assignRole = selectedUser.role;

          // this.assignRoleAdmin = this.assignRole !== "ADMIN";

          this.f["assignToUserName"].setValue(this.assignToUserName);
        }
      },
    });
  }

  loadUserid() {
    const permissions = localStorage.getItem("permissions");
    if (permissions) {
      try {
        const parsedPermissions = JSON.parse(permissions);
        const getUserId = parsedPermissions.USER;
        const getUserRole = parsedPermissions.role;
        this.userRole = getUserRole;
        if (getUserId) {
          if (getUserRole === 'ADMIN' || getUserRole === 'DASHBOARD') {
            this.assignTo = '';
          }
          else {
            this.assignTo = getUserId;

          }
        }

      } catch (error) {
        console.error("Error parsing localStorage data:", error);
      }
    }
  }
  filterAssignee(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm) {
      this.usersList = this.usersListOriginal.filter((assignee) =>
        assignee.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.usersList = [...this.usersListOriginal];
    }
  }
  onAssigneeSelect(selectedUserId: string) {
    const selectedUser = this.usersList.find(
      (user) => user.userId === selectedUserId

    );
    console.log("in loop");
    if (selectedUser) {
      console.log("safsa", selectedUser)
      this.assignTo = selectedUser.userId;
      this.f["assignTo"].setValue(this.assignTo, { emitEvent: false });

      this.assignToUserName = selectedUser.userName;
      this.f["assignToUserName"].setValue(this.assignToUserName, {
        emitEvent: false,
      });
    }
    else {
      this.assignTo = '';
    }
  }

  private getDefaultDateFrom(): Date {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
  }
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;

    this.dataSource.sortingDataAccessor = (item, property) => {
      const value = item[property];
      return typeof value === "string" ? value.toLowerCase() : value;
    };
  }
  resetPagination() {
    this.pageNo = 0;
    this.rawData = [];
    this.length = 0;
  }

  getTotalComplaintsByUserStatusCount() {
    const filters = {
      dateFrom: this.datePipe.transform(this.form.value.dateFrom, "yyyy-MM-dd"),
      dateTo: this.datePipe.transform(this.form.value.dateTo, "yyyy-MM-dd"),
      assignTo: this.f["assignTo"].value,
    };

    this.appDataService.getTotalComplaintsByUserStatusCount(filters).subscribe({
      next: (res: any) => {
        if (res?.data?.length) {
          const stats: any = {};
          res.data.forEach((item: any) => {
            const [number, statusString] = item;
            const key = statusString?.replaceAll(" ", "") ?? "";
            stats[key] = {
              status: statusString,
              value: number,
            };
          });
          this.complaintsByStatus = stats;
        } else {
          this.complaintsByStatus = {};
        }
      },
      error: (err) => {
        console.error("Error fetching complaints by status:", err);
      },
    });
  }

  getTotalComplaintsByComplaintSummaryCount(statusKey: string | null) {
    if (!statusKey) {
      console.error('Invalid status key');
      return;
    }
    if (this.selectedStatus !== statusKey) {
      this.pageNo = 0;
    }

    this.selectedStatus = statusKey;

    const status = this.complaintsByStatus?.[statusKey]?.status;

    if (!status || this.complaintsByStatus?.[statusKey]?.value === 0) {
      this.rawData = [];
      this.length = 0;
      this.cdr.detectChanges();
      return;
    }

    const filters = {
      dateFrom: this.datePipe.transform(this.form.value.dateFrom, "yyyy-MM-dd"),
      dateTo: this.datePipe.transform(this.form.value.dateTo, "yyyy-MM-dd"),
      assignTo: this.assignTo,
      name: status,
      pageSize: this.pageSize,
      pageNo: this.pageNo,
    };

    console.log("Filters Sent:", filters);

    this.appDataService
      .getTotalComplaintsByComplaintSummaryCount(filters)
      .subscribe({
        next: (res: any) => {
          console.log("API Response:", res);

          if (res?.data?.data?.length) {
            this.rawData = res.data.data.map((complaint: any) => ({
              complaintId: complaint[11],
              complaintNo: complaint[28],
              complainantName: complaint[24],
              complaintType: complaint[3],
              cnic: complaint[23],
              complaintDetails: complaint[27],
              name: complaint[24],
            }));

            this.length = res.data.totalRows;
            console.log("Mapped rawData:", this.rawData);
            this.cdr.detectChanges();
          } else {
            console.log("No data returned for the selected status.");
            this.rawData = [];
            this.length = 0;
            this.cdr.detectChanges();
          }
        },
        error: (err) => {
          console.error("Error fetching complaints:", err);
          this.rawData = [];
          this.length = 0;
          this.cdr.detectChanges();
        },
      });
  }
  handleCardClick(statusKey: string, event: MouseEvent) {
    this.clearCardSelection();
    this.selectedStatus = statusKey;
    this.getTotalComplaintsByComplaintSummaryCount(statusKey);

    const target = event.target as HTMLElement;
    const card = target.closest('.dash-card');
    card?.classList.add('green-outline');
  }
  clearCardSelection() {
    this.selectedStatus = null;
    document.querySelectorAll('.dash-card').forEach(card => {
      card.classList.remove('green-outline');
    });
  }
  clearFields() {
    this.form.reset({
      dateFrom: this.getDefaultDateFrom(),
      dateTo: new Date(),
    });
    this.clearCardSelection();
    this.resetPagination();
  }



  handlePageEvent(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageNo = event.pageIndex;

    if (this.selectedStatus) {
      this.getTotalComplaintsByComplaintSummaryCount(this.selectedStatus);
    } else {
      console.warn('Pagination changed with no selected status');
      this.rawData = [];
      this.length = 0;
    }
  }

  viewComplaint(complaint: any) {
    const path = this.router.serializeUrl(
      this.router.createUrlTree(['complaint', 'view', complaint.complaintId])
    );
    window.open(this.location.prepareExternalUrl(path), '_blank');
  }

  truncateText(text: string, limit: number): string {
    if (!text) return "";
    return text.length > limit
      ? text.replace(/<\/?[^>]+(>|$)/g, "").substring(0, limit) + "..."
      : text;
  }
}
